import ParameterValue from './ParameterValue';
import ParameterGroup from './ParameterGroup';
import RefTimeGroup from './RefTimeGroup';
import ReanalysisPointGroup from './ReanalysisPointGroup';
import RefTimeValue from './RefTimeValue';

export default class WapiReanalysisMessageViewModel {
  constructor() {
    this.latitudes = [];
    this.longitudes = [];
    this.parameters = [];
    this.reftimes = [];
    this.values = [];
    this.tile_size = {};
    this.refTimeGroups = [];
    this.pointsGroups = [];
  }

  map(wapiReanalysisMessage) {
    this.latitudes = wapiReanalysisMessage.latitudes;
    this.longitudes = wapiReanalysisMessage.longitudes;
    this.parameters = wapiReanalysisMessage.parameters;
    this.reftimes = wapiReanalysisMessage.reftimes;
    this.values = wapiReanalysisMessage.values;
    this.tile_size = wapiReanalysisMessage.tile_size;

    for (let p = 0; p < this.parameters.length; p++) {
      const reftime_start = this.reftimes.length * p;
      const reftime_end = this.reftimes.length * (p + 1);

      for (let reftime_index = reftime_start; reftime_index < reftime_end; reftime_index++) {
        const point_start = this.latitudes.length * reftime_index;
        const point_end = this.latitudes.length * (reftime_index + 1);

        for (let point_index = point_start; point_index < point_end; point_index++) {
          const value = this.values[point_index];
          const parameter = this.parameters[p];
          const refTime = this.reftimes[reftime_index - reftime_start];
          const latitude = this.latitudes[point_index - point_start];
          const longitude = this.longitudes[point_index - point_start];

          let pointGroup = this.pointsGroups.find(x => x.latitude === latitude && x.longitude === longitude);
          if (!pointGroup) {
            pointGroup = new ReanalysisPointGroup(latitude, longitude)
            this.pointsGroups.push(pointGroup);
          }

          let refTimeGroup = pointGroup.refTimeGroups.find(x => x.refTime == refTime);
          if (refTimeGroup) {
            refTimeGroup.values.push(new ParameterValue(parameter.sname, value, parameter.level_type, parameter.level, parameter.sname, parameter.pname, parameter.unit));
          } else {
            refTimeGroup = new RefTimeGroup(refTime);
            pointGroup.refTimeGroups.push(refTimeGroup);
            refTimeGroup.values.push(new ParameterValue(parameter.sname, value, parameter.level_type, parameter.level, parameter.sname, parameter.pname, parameter.unit));
          }

          let parameterGroup = pointGroup.parameterGroups.find(x => x.code == parameter.sname);
          if (parameterGroup) {
            parameterGroup.values.push(new RefTimeValue(refTime, value));
          } else {
            parameterGroup = new ParameterGroup(parameter.sname);
            pointGroup.parameterGroups.push(parameterGroup);
            parameterGroup.values.push(new RefTimeValue(refTime, value));
          }
        }

      }

    }

    return this;
  }
}
